import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class BookingID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
